import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme?: Theme) => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  paper: {
    padding: 24,
    backgroundColor: "#FFF",
    borderColor: "#E8EAEF",
    borderRadius: "8px",
    marginBlockStart: 32,
  },
  card: {
    backgroundColor: "#FAFBFC",
    "& .MuiCardContent-root": {
      [theme.breakpoints.down("sm")]: {
        paddingInline: 0,
        paddingBlock: "2rem",
      },
    },
  },
  title: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
    textAlign: "center",
  },
  subtitle: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500,
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(12),
    },
  },
  container: {
    gridGap: 8.5,
    marginBlock: "32px 30px",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
  },
  button: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    textTransform: "none",
    "& svg path": {
      fill: "#22D9BB",
    },
  },
}));
